const MetaBadges = ({ projectData }) => {
  const data = projectData?.project_data;

  return (
    <div className="row align-items-center mb-4 px-3">
      <div className="col-auto badge-custom">
        <i className="bi bi-person-badge" />
        {projectData?.project_data?.client}
      </div>
      <div className="col-auto badge-custom">
        <i className="bi bi-person-lines-fill" /> PM:{" "}
        {data?.project_manager_first_name} {data?.project_manager_last_name}
      </div>
      <div className="col-auto badge-custom">
        <i className="bi bi-building" />{" "}
        {data?.office_location || "Not Defined"}
      </div>
      <div className="col-auto badge-custom">
        <i className="bi bi-clock-fill" /> {data?.start_date} -{" "}
        {data?.end_date || "Not Defined"}
      </div>
      <div className="col-auto badge-custom">
        <i className="bi bi-tag" /> {data?.market_segment || "Not Defined"}
      </div>
      <div className="col-auto badge-custom">
        <i className="bi bi-calculator" />{" "}
        {data?.project_type === 1 ? "Billable" : "Non Billable"}
      </div>
      <div className="col-auto ms-auto badge-custom">
        <div className="dropdown">
          <button
            className="btn dropdown-toggle btn-sm"
            data-bs-toggle="dropdown"
          >
            <i className="fas fa-file pe-2" /> Files
          </button>
          <ul className="dropdown-menu">
            {data?.attachments?.map((file, index) => (
              <li key={index}>
                <a
                  className="dropdown-item"
                  href={file.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {file.document_name}
                </a>
              </li>
            ))}

            {/* If no attachments */}
            {(!data?.attachments ||
              projectData.project_data?.attachments.length === 0) && (
              <li className="dropdown-item text-muted">No attachments found</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MetaBadges;
